import { Button, ButtonProps } from '@progress/kendo-react-buttons';
import { KwelloSvgIcon } from 'common/components/icon/KwelloSvgIcon';

interface CustomButtonProps extends ButtonProps {
  icon?: any;
  text?: string;
  className?: string;
}

export default function CustomButton({
  icon,
  text,
  className,
  fillMode = 'flat',
  size = 'medium',
  themeColor = 'base',
  children,
  ...rest
}: CustomButtonProps) {
  return (
    <Button className={className} fillMode={fillMode} size={size} themeColor={themeColor} {...rest}>
      {icon && <KwelloSvgIcon icon={icon} />}
      {text}
      {children}
    </Button>
  );
}
